import React, { useEffect, useState } from 'react'

import { Button } from '../../components/button/button.js'
import { Modal, ModalContent, ModalFooter, ModalHeader, ModalProvider } from '../../components/modal/modal.js'
import i18n from '../../i18n.js'

import './auth-refresher.scss'

export interface AuthRefresherProps {
    authExp?: number
    onCancel: () => void
    onContinue: () => Promise<void>
}

export const AuthRefresher = (props: AuthRefresherProps) => {
    const [timeLeft, setTimeLeft] = useState<number>()
    const [modalOpen, setModalOpen] = useState<boolean>(false)
    let timeoutInterval: number

    const getCurrentTimestamp = () => {
        return Math.floor(Date.now() / 1000)
    }

    const maybeOpenLogOutNotification = () => {
        if (timeLeft && timeLeft <= 60) {
            setModalOpen(true)
            return
        }
    }

    useEffect(() => {
        maybeOpenLogOutNotification()

        if (timeLeft && timeLeft <= 0) {
            setModalOpen(false)
            onCancel()
        }
        /* eslint-disable-next-line */
    }, [timeLeft])

    // Time left calculations:

    const updateTimeLeft = () => {
        if (props.authExp) {
            const currentTimestamp = getCurrentTimestamp()
            setTimeLeft(Math.max(-1, props.authExp - currentTimestamp))
        }

        timeoutInterval = window.setTimeout(updateTimeLeft, 1000)
    }

    useEffect(() => {
        updateTimeLeft()

        return () => {
            window.clearTimeout(timeoutInterval)
        }
        /* eslint-disable-next-line */
    }, [props.authExp, timeLeft])

    const onCancel = () => {
        props.onCancel()
        window.clearTimeout(timeoutInterval)
    }

    const onContinue = () => {
        props
            .onContinue()
            .then(() => {
                setModalOpen(false)
            })
            .catch((_e) => {
                /* do nothing */
            })
    }

    return (
        <ModalProvider isClosable={false} defaultIsOpen={false}>
            <Modal className="modal--dialog" isOpen={modalOpen}>
                <ModalHeader>
                    <h1>
                        {i18n.t('sessionExpires.title')}{' '}
                        <span className="auth-refresher__count-down"> {timeLeft || ''} </span>
                    </h1>
                </ModalHeader>
                <ModalContent>
                    <div className="text">
                        <p>{i18n.t('sessionExpires.description')}</p>
                    </div>
                </ModalContent>
                <ModalFooter>
                    <div className="auth-refresher__actions">
                        <Button text={i18n.t('sessionExpires.cancelButtonText')} onClick={onCancel} />
                        <Button text={i18n.t('sessionExpires.continueButtonText')} onClick={onContinue} />
                    </div>
                </ModalFooter>
            </Modal>
        </ModalProvider>
    )
}
